import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import { Button, FontIcon } from "react-md";


import Buttons from "../components/Buttons";
import RequestMe_and_RequestsOther from "../components/RequestMe_and_RequestsOther";

import { getPerson } from "../actions/resourceActions";
import { getRequest } from "../actions/requestActions";
import {DebugElement} from "../Atollon/debug";
import Translate from "../Atollon/Translation";
import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween} from "../AtollonTheme/ReactElements";

const Person = ({ history, person }) => {
  if (!person) return <div />;
  return (
    <div className="flex-col">

        <TouchPageHeader
            title={<div style={{lineHeight:"130%"}}>{person.name}<br/>({person.identifier})</div>}
            debugText={"src/containers/Person.js"}
        />
        <TouchPageHeader_and_content_spaceBetween heightPx={50}/>

        {/*
      <DebugElement text={"src/containers/Person.js"}/>
      <div className="flex-row flex-align-center margin-bottom">
        <span className="margin-horizontal">
          <FontIcon>person</FontIcon>
        </span>
        <div className="flex-col margin-horizontal">
          <span>{person.name}</span>
          <span>{person.identifier}</span>
        </div>
      </div>
      <Buttons
        history={history}
        primary={[
          {
            label: "Nový požadavek",
            link: "/request-new"
          }
        ]}
        buttons={[
          {
            label: "Zadat přijatý požadavek",
            link: "/request-received"
          }
        ]}
        className="margin-bottom"
      />
      */}
      <RequestMe_and_RequestsOther history={history} />
    </div>
  );
};


export default compose(
  connect(({ resource: { person } }) => ({ person }), {
    getPerson,
    getRequest
  }),
  lifecycle({
    async componentWillMount() {
      const { getPerson, match, getRequest } = this.props;

      await getPerson(match.params.id);
      getRequest({
        recipient: match.params.id,
        sender: match.params.id,
        includeCount: "true",
        limit: 5,
        side: "PENDING",
        status: "INITIAL,ACCEPTED,RESOLVING"
      });
      getRequest({
        recipient: match.params.id,
        sender: match.params.id,
        includeCount: "true",
        limit: 5,
        side: "NOT_PENDING",
        status: "INITIAL,ACCEPTED,RESOLVING"
      });
    }
  })
)(Person);



// WEBPACK FOOTER //
// ./src/pages/Person.js